import { render, staticRenderFns } from "./ModifierSets.vue?vue&type=template&id=6cc1b6c8&scoped=true"
import script from "./ModifierSets.vue?vue&type=script&lang=js"
export * from "./ModifierSets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc1b6c8",
  null
  
)

export default component.exports